import React, { useState, useEffect, useRef } from 'react';
import { AppBar, Toolbar, Typography, Box, Button, IconButton, makeStyles } from '@material-ui/core';
import logo from '../../assets/image/logo.png';
import MenuNav from '../menu/MenuNav';

const Header = () => {
    const classes = useStyles();
    const [isSticky, setIsSticky] = useState(false);
    const menuRef = useRef(null);

    useEffect(() => {
        const handleScroll = () => {
            if (menuRef.current) {
                const menuOffsetTop = menuRef.current.offsetTop;
                if (window.scrollY > menuOffsetTop) {
                    setIsSticky(true);
                } else {
                    setIsSticky(false);
                }
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    return (
        <Box >
            <Box bgcolor="#1e4474" color="yellow" className={classes.menuParent}>
                <Box className={classes.menuLogo}>
                    <img src={logo} alt="Ford Logo" width="100" />
                </Box>
                <Box py={1} px={2} display="flex" justifyContent="center" alignItems="center">
                    <Typography variant="body1" className={classes.txtPhuTrach}>
                        Phụ Trách Kinh Doanh - Hoàng Minh Quân: 0966.122.815
                    </Typography>
                </Box>
            </Box>


            {/* Thanh menu */}
            <Box
                position={isSticky ? "fixed" : "static"}
                top={0}
                left={0}
                right={0}
                sx={{
                    transition: isSticky ? 'none' : 'height 0.3s ease', // Không transition khi sticky
                }}
                ref={menuRef}
                className={classes.boxMenu}
            >
                <MenuNav />
            </Box>

        </Box>
    );
};

const useStyles = makeStyles((theme) => ({
    txtPhuTrach: {
        fontSize: '20px',
        fontWeight: 600
    },
    menuParent: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center', // Thêm alignItems để căn giữa theo chiều dọc
        [theme.breakpoints.down('xs')]: {
            justifyContent: 'left'
        }
    },
    menuLogo: {
        [theme.breakpoints.down('xs')]: {
            display: 'none',
        },
        marginRight: '50px'
    },
    boxMenu: {
        backgroundColor: '#0057b8',
        zIndex: 1000, // Đảm bảo menu ở trên các phần tử khác
        display: 'flex',
        justifyContent: 'center',
        [theme.breakpoints.down('xs')]: {
            justifyContent: 'left',
        }
    }

}));

export default Header;
